import { render, staticRenderFns } from "./distribuicao_de_nota_faixa.vue?vue&type=template&id=41abc02e&scoped=true&"
import script from "./distribuicao_de_nota_faixa.vue?vue&type=script&lang=js&"
export * from "./distribuicao_de_nota_faixa.vue?vue&type=script&lang=js&"
import style0 from "./distribuicao_de_nota_faixa.vue?vue&type=style&index=0&id=41abc02e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41abc02e",
  null
  
)

export default component.exports